import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

import { TextConstants } from "@shared/constants";

export enum AddLocationOptionEnum {
  MANUAL_ENTRY,
  GEOJSON_FILES,
}

@Component({
  standalone: false,
  selector: "app-add-location-options-dialog",
  templateUrl: "./add-location-options-dialog.component.html",
  styleUrls: ["./add-location-options-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddLocationOptionsDialogComponent {
  constructor(public dialogRef: MatDialogRef<AddLocationOptionsDialogComponent>) {}

  readonly translations = {
    cancel: TextConstants.CANCEL,
  };

  public onManualEntryClick(): void {
    this.dialogRef.close(AddLocationOptionEnum.MANUAL_ENTRY);
  }

  public onGeojsonFilesClick(): void {
    this.dialogRef.close(AddLocationOptionEnum.GEOJSON_FILES);
  }

  public onClose(): void {
    this.dialogRef.close();
  }
}
